import ReactOnRails from 'react-on-rails';
import App from '../bundles/App';
import "../bundles/stylesheets/style.scss";

// This is how react_on_rails can see the HelloWorld in the browser.
ReactOnRails.register({
  App
});